export enum HttpMethods {

    Get = 'GET',
    Post = 'POST'

}